import React from 'react';
import logo from './logo.svg';
import './App.css';
import AppRouting from './routing/AppRouting';

function App() {
  return (
    <AppRouting />
  );
}

export default App;
